(function() {
  angular
    .module('specsguardApp')
    .controller('sgWidgetsCtrl', sgWidgetsCtrl);

  sgWidgetsCtrl.$inject = ['$scope'];

  function sgWidgetsCtrl ($scope) {

  }
})();
